(function (window, document) {
  'use strict';
  if (window.HLXConsent?.version === 1) return;
  if (window.Shopify?.shop !== 'healthlabs-pharm.myshopify.com') return;
  if (!['eu.healthlabspharm.com', 'healthlabs-pharm.myshopify.com'].includes(window.location?.hostname)) return;

  let lastUpdate = '';
  let attempts = 0;
  let requested = false;
  let timer;
  let wasReady = false;

  function permissions() {
    const denied = { ready: false, marketing: false, analytics: false, preferences: false, sharing: false };
    try {
      const privacy = window.Shopify?.customerPrivacy;
      if (!['marketingAllowed', 'analyticsProcessingAllowed', 'preferencesProcessingAllowed', 'saleOfDataAllowed']
        .every(name => typeof privacy?.[name] === 'function')) return denied;
      return {
        ready: true,
        marketing: privacy.marketingAllowed() === true,
        analytics: privacy.analyticsProcessingAllowed() === true,
        preferences: privacy.preferencesProcessingAllowed() === true,
        sharing: privacy.saleOfDataAllowed() === true
      };
    } catch (_) {
      return denied;
    }
  }

  function sync() {
    const state = permissions();
    const signal = allowed => allowed ? 'granted' : 'denied';
    const update = {
      ad_storage: signal(state.marketing),
      analytics_storage: signal(state.analytics),
      ad_user_data: signal(state.marketing && state.sharing),
      ad_personalization: signal(state.marketing && state.sharing),
      functionality_storage: signal(state.preferences),
      personalization_storage: signal(state.preferences),
      security_storage: 'granted'
    };
    const signature = JSON.stringify(update);
    try {
      if (signature !== lastUpdate && typeof window.gtag === 'function') {
        window.gtag('consent', 'update', update);
        lastUpdate = signature;
      }
    } catch (_) {}
    const becameReady = state.ready && !wasReady;
    wasReady = state.ready;
    if (becameReady) document.dispatchEvent(new Event('hlx:consent-ready'));
    return state;
  }

  function load() {
    if (sync().ready) {
      window.clearTimeout(timer);
      return;
    }
    if (attempts++ >= 10) return;
    if (!requested && typeof window.Shopify?.loadFeatures === 'function') {
      requested = true;
      try {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => {
          requested = !error;
          if (sync().ready) window.clearTimeout(timer);
        });
      } catch (_) {
        requested = false;
      }
    }
    if (!permissions().ready) timer = window.setTimeout(load, 500);
  }

  window.HLXConsent = Object.freeze({
    version: 1,
    getState: sync,
    marketingAllowed: () => sync().marketing,
    enhancedDataAllowed: () => {
      const state = sync();
      return state.marketing && state.sharing;
    }
  });
  document.addEventListener('visitorConsentCollected', sync);
  load();
})(window, document);
